import styled from 'styled-components';

import { zindex } from 'utils/style/zindex';

export const Container = styled.div`
  position: relative;
  cursor: help;
  display: inline-block;
  max-width: 100%;
`;

export const TooltipText = styled.span`
  min-width: 100px;
  padding: 10px 8px;
  margin-top: 15px;
  background-color: black;
  color: var(--exact-white);
  border-radius: 3px;
  z-index: ${zindex.popover};
  position: absolute;
  top: 100%;
  left: 50%;
  text-align: center;
  max-width: calc(100% - 4px);
  pointer-events: none;
  opacity: 0.1;
  transform: translateX(-50%);
  transition: all 0.2s ease-in 0.2s;
  visibility: hidden;
  &:before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    border-bottom: 5px solid black;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    left: 50%;
    transform: translateX(-50%);
    bottom: 100%;
  }
`;

export const Source = styled.div`
  &:hover + ${TooltipText} {
    opacity: 1;
    visibility: visible;
    margin-top: 10px;
  }
`;
